import { useQuery } from '@tanstack/react-query';
import type { PublishedTimelineResponse } from '@tempo-io/roadmap-dto';

interface UseExportTimelineParams {
  viewId: number;
  visualizationId: number;
  token: string;
}

export function useExportTimeline({ viewId, visualizationId, token }: UseExportTimelineParams) {
  return useQuery<PublishedTimelineResponse, Error>({
    queryKey: ['export-timeline', viewId, visualizationId, token],
    queryFn: async () => {
      const url = `/export-api/v1/loop-visualization/view/${viewId}/visualization/${visualizationId}/timeline?token=${encodeURIComponent(token)}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          throw new Error('Invalid or expired export token');
        }
        if (response.status === 404) {
          throw new Error('Visualization not found');
        }
        throw new Error(`Failed to fetch visualization: ${response.statusText}`);
      }

      const data = await response.json();
      return data as PublishedTimelineResponse;
    },
    retry: false,
    staleTime: 0,
  });
}
